
{
  "fr": {
    "getQuotationModal": {
      "title": "Envoyer le projet par mail",
      "submitLabel": "Envoyer le projet",
      "email": "Email du destinataire"
    }
  }
}
